module.exports = __webpack_public_path__ + "img/view-attach-icon.27cd283f.svg";